module.exports = __webpack_public_path__ + "media/images/jod-baby-a26b1c638f47f96ff54d01eea587301c.jpg";